export default __webpack_public_path__ + "static/media/go-logo.0aba6188.svg";